import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M16 21h-4","key":"svg-0"}],["path",{"d":"M14 21v-18","key":"svg-1"}],["path",{"d":"M14 4l-9 4l9 4","key":"svg-2"}]]

const IconPennant2 = createReactComponent('outline', 'pennant-2', 'Pennant2', __iconNode);

export default IconPennant2;